import { useBrowsePresetApi } from '@aibees/shared/api';
import { HttpMethod } from '@aibees/shared/definition';
import { MutationOptions } from '@aibees/shared/http';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { PRESET_API_PREFIX } from './constants';

export function useDeletePresetMutationApi(
  id?: string,
  options?: MutationOptions
) {
  const workspace = useWorkspace()?.id;
  return useBaseMutation(
    {
      url: `${PRESET_API_PREFIX.replace(':id', String(workspace))}/${id}`,
      method: HttpMethod.delete,
    },
    {
      ...options,
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useBrowsePresetApi.name]);
      },
      onMutate() {},
    }
  );
}
